export const ACTIVITY = 'activity';
export const CONTEXT = 'context';
export const EMOTION_T0 = 'emotion-type0';
export const EMOTION_T1 = 'emotion-type1';
export const UNIT = 'unit';
